export default __webpack_public_path__ + "../staticImages/liefergarantie-260.png";